var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-card',{attrs:{"bordered":false,"body-style":{ padding: 0}}},[_c('a-table',{ref:"table",attrs:{"size":"small","bordered":"","rowKey":"id","scroll":{ x:800 },"columns":_vm.columns,"dataSource":_vm.dataSource,"pagination":_vm.ipagination,"loading":_vm.loading,"rowSelection":{
      selectedRowKeys: _vm.selectedRowKeys,
      columnWidth: 40,
      getCheckboxProps: _vm.getCheckboxProps,
      onChange: _vm.onMySelectChange
    }},on:{"change":_vm.handleTableChange},scopedSlots:_vm._u([{key:"title",fn:function(currentPageData){return [_c('h3',[_vm._v("应收单")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }